import React, { useEffect, useMemo, useState } from "react";
import {
  getVendorCompanyId,
  numberWithCommas,
  smartDecimalNumberFormatter,
  truncateDescription,
} from "../../../services/commonService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useCompetitorContext } from "../../../context/CompetitorContext";

//Old Api response for bu and geo wise revenue analysis
// TEMP: Dummy data until API is fixed
// const DUMMY_BU_WISE_REVENUE = [
//   {
//     name: "Diagnostics",
//     FY2023: 1250.45,
//     FY2024: 1385.2,
//     bu_pie_share: 42,
//     bu_revenue_growth: 10.8,
//   },
//   {
//     name: "Life Sciences",
//     FY2023: 980.1,
//     FY2024: 1025.6,
//     bu_pie_share: 33,
//     bu_revenue_growth: 4.6,
//   },
//   {
//     name: "Digital Solutions",
//     FY2023: 420.0,
//     FY2024: 510.75,
//     bu_pie_share: 25,
//     bu_revenue_growth: 21.6,
//   },
// ];

// const DUMMY_GEO_WISE_REVENUE = [
//   {
//     name: "North America",
//     FY2023: 1420.3,
//     FY2024: 1580.9,
//     geo_segment_pie_share: 48,
//     yoy_rate: 11.3,
//   },
//   {
//     name: "Europe",
//     FY2023: 760.5,
//     FY2024: 805.2,
//     geo_segment_pie_share: 26,
//     yoy_rate: 5.9,
//   },
//   {
//     name: "Asia Pacific",
//     FY2023: 470.2,
//     FY2024: 535.8,
//     geo_segment_pie_share: 18,
//     yoy_rate: 14.0,
//   },
//   {
//     name: "Rest of World",
//     FY2023: 210.4,
//     FY2024: 235.6,
//     geo_segment_pie_share: 8,
//     yoy_rate: 12.0,
//   },
// ];


// New api response for bu and geo wise revenue analysis
// {
//   "business_segments": [
//     {
//       "name": "Pharmaceuticals - Roche Pharmaceuticals",
//       "2025": 60619.206746,
//       "2024": 51138.846572,
//       "2023": 52328.812693,
//       "2022": 49469.540498,
//       "2021": 50140.959404
//     },
//     {
//       "name": "Pharmaceuticals - Chugai",
//       "2025": 8858.061667,
//       "2024": 7594.517643,
//       "2023": 8554.022282,
//       "2022": 10025.198182,
//       "2021": 9168.39438
//     },
//     {
//       "name": "Diagnostics",
//       "2025": 17610.189794,
//       "2024": 15961.508746,
//       "2023": 17402.560394,
//       "2022": 19247.947922,
//       "2021": 19591.711369
//     },
//     {
//       "name": "Elimination",
//       "2025": -7188.347309,
//       "2024": -5839.899356,
//       "2023": -6507.849799,
//       "2022": -7567.023913,
//       "2021": -6666.227883
//     }
//   ],
//   "geo_segments": [
//     {
//       "name": "Switzerland",
//       "2025": 1696.197742,
//       "2024": 1357.346222,
//       "2023": 1327.696364,
//       "2022": 1205.835596,
//       "2021": 2322.265004
//     },
//     {
//       "name": "Germany",
//       "2025": 3937.196544,
//       "2024": 3242.181464,
//       "2023": 3435.622166,
//       "2022": 3588.307181,
//       "2021": 4737.771635
//     },
//     {
//       "name": "Rest of Europe",
//       "2025": 13695.693294,
//       "2024": 11356.463393,
//       "2023": 11522.931862,
//       "2022": 11167.22723,
//       "2021": 12484.505436
//     },
//     {
//       "name": "United States",
//       "2025": 38746.45311,
//       "2024": 33295.813184,
//       "2023": 33669.809765,
//       "2022": 31644.803019,
//       "2021": 30786.191465
//     },
//     {
//       "name": "Rest of North America",
//       "2025": 1238.413519,
//       "2024": 981.041294,
//       "2023": 995.178491,
//       "2022": 1191.776526,
//       "2021": 1004.815656
//     },
//     {
//       "name": "Latin America",
//       "2025": 4092.313512,
//       "2024": 3585.380387,
//       "2023": 3528.252145,
//       "2022": 3103.810009,
//       "2021": 3012.253047
//     },
//     {
//       "name": "Japan",
//       "2025": 3933.413203,
//       "2024": 3631.728795,
//       "2023": 5301.284946,
//       "2022": 6975.461518,
//       "2021": 5560.491877
//     },
//     {
//       "name": "China",
//       "2025": 6072.261806,
//       "2024": 5983.358713,
//       "2023": null,
//       "2022": null,
//       "2021": null
//     },
//     {
//       "name": "Rest of Asia",
//       "2025": 4772.053722,
//       "2024": 4042.243262,
//       "2023": 10557.442466,
//       "2022": 10654.611919,
//       "2021": 10708.526673
//     },
//     {
//       "name": "Africa, Australia and Oceania",
//       "2025": 1715.114446,
//       "2024": 1379.416893,
//       "2023": 1439.327364,
//       "2022": 1643.829691,
//       "2021": 1618.016476
//     }
//   ]
// }

const DUMMY_BU_WISE_REVENUE = [];
const DUMMY_GEO_WISE_REVENUE = [];

export default function RevenueAnalysis() {
  const { competitorInfo } = useCompetitorContext();
  const vendorCompanyId = getVendorCompanyId(competitorInfo);
  // const USE_DUMMY_DATA = true;
  const USE_DUMMY_DATA = !vendorCompanyId ? true : false;


  //New api to fetch geo and business data
  const transformBusinessSegments = (segments = []) => {
    if (!segments.length) return [];

    const years = Object.keys(segments[0])
      .filter((k) => !isNaN(k))
      .sort((a, b) => b - a)
      .slice(0, 2);

    const latestYear = years[0];
    const prevYear = years[1];

    const totalLatestRevenue = segments.reduce(
      (sum, item) => sum + (item?.[latestYear] || 0),
      0
    );

    return segments.map((item) => {
      const latest = item?.[latestYear] || 0;
      const previous = item?.[prevYear] || 0;

      const growth =
        previous !== 0
          ? ((latest - previous) / Math.abs(previous)) * 100
          : 0;

      return {
        name: item.name,
        [`FY${latestYear}`]: latest,
        [`FY${prevYear}`]: previous,
        bu_pie_share:
          totalLatestRevenue !== 0
            ? (latest / totalLatestRevenue) * 100
            : 0,
        bu_revenue_growth: growth,
      };
    });
  };

  const transformGeoSegments = (segments = []) => {
    if (!segments.length) return [];

    const years = Object.keys(segments[0])
      .filter((k) => !isNaN(k))
      // .filter((k) => /^\d{4}$/.test(k))
      .sort((a, b) => b - a)
      .slice(0, 2);

    const latestYear = years[0];
    const prevYear = years[1];

    const totalLatestRevenue = segments.reduce(
      (sum, item) => sum + (item?.[latestYear] || 0),
      0
    );

    return segments.map((item) => {
      const latest = item?.[latestYear] || 0;
      const previous = item?.[prevYear] || 0;

      const growth =
        previous !== 0
          ? ((latest - previous) / Math.abs(previous)) * 100
          : 0;

      return {
        name: item.name,
        [`FY${latestYear}`]: latest,
        [`FY${prevYear}`]: previous,
        geo_segment_pie_share:
          totalLatestRevenue !== 0
            ? (latest / totalLatestRevenue) * 100
            : 0,
        yoy_rate: growth,
      };
    });
  };

  // const { bu_wise_revenue_analysis, bu_wise_revenue_analysis_loading } =
  //   useSelector((state) => state.fetchRevenueAnalysisReducer);

  // const { geo_wise_revenue_analysis, geo_wise_revenue_analysis_loading } =
  //   useSelector((state) => state?.fetchGeoWiseRevenueAnalysisReducer);

  const reduxBU = useSelector((state) => state.fetchRevenueAnalysisReducer);

  // const reduxGeo = useSelector(
  //   (state) => state?.fetchGeoWiseRevenueAnalysisReducer
  // );
  const reduxGeo = useSelector((state) => state.fetchRevenueAnalysisReducer);

  // const bu_wise_revenue_analysis = USE_DUMMY_DATA
  //   ? DUMMY_BU_WISE_REVENUE
  //   : reduxBU?.bu_wise_revenue_analysis;
  const bu_wise_revenue_analysis = useMemo(() => {
    return USE_DUMMY_DATA
      ? DUMMY_BU_WISE_REVENUE
      : transformBusinessSegments(
        reduxBU?.bu_wise_revenue_analysis?.business_segments
      );
  }, [USE_DUMMY_DATA, reduxBU?.bu_wise_revenue_analysis?.business_segments]);

  const bu_wise_revenue_analysis_loading = USE_DUMMY_DATA
    ? false
    : reduxBU?.bu_wise_revenue_analysis_loading;

  // const geo_wise_revenue_analysis = USE_DUMMY_DATA
  //   ? DUMMY_GEO_WISE_REVENUE
  //   : reduxGeo?.geo_wise_revenue_analysis;
  const geo_wise_revenue_analysis = useMemo(() => {
    return USE_DUMMY_DATA
      ? DUMMY_GEO_WISE_REVENUE
      : transformGeoSegments(
        reduxGeo?.bu_wise_revenue_analysis?.geo_segments
      );
  }, [USE_DUMMY_DATA, reduxGeo?.bu_wise_revenue_analysis?.geo_segments]);

  const geo_wise_revenue_analysis_loading = USE_DUMMY_DATA
    ? false
    : reduxGeo?.bu_wise_revenue_analysis_loading;

  const [segmentsLatestYearsFields, setSegmentsLatestYearsFields] = useState({
    fy_fields: [],
    fy_years: [],
  });
  const [geoLatestYearsFields, setGeoLatestYearsFields] = useState({
    fy_fields: [],
    fy_years: [],
  });

  const [revenueBySegmentsTableData, setRevenueBySegmentsTableData] = useState(
    []
  );

  const [revenueByGeographyTableData, setRevenueByGeographyTableData] =
    useState([]);

  const fetchRevenueAnalysisData = async () => {
    const buLatestFYYears = Object.keys(bu_wise_revenue_analysis?.[0] || {})
      .filter((year) => year?.startsWith("FY"))
      .sort((a, b) => b.localeCompare(a))
      .slice(0, 2)
      .sort((a, b) => a.localeCompare(b)); // Get the latest two years

    const buLatestYears = Object.keys(bu_wise_revenue_analysis?.[0] || {})
      .filter((year) => year.startsWith("FY")) // Get only financial years
      .sort((a, b) => b.localeCompare(a)) // Sort in descending order
      .slice(0, 2) // Get the latest two years
      .map((year) => year.replace("FY", "")) // Remove "FY"
      .sort((a, b) => a.localeCompare(b)); // Sort in ascending order

    setSegmentsLatestYearsFields({
      fy_fields: buLatestFYYears,
      fy_years: buLatestYears,
    });
    setRevenueBySegmentsTableData(bu_wise_revenue_analysis || []);

    const geoLatestFYYears = Object.keys(geo_wise_revenue_analysis?.[0] || {})
      .filter((year) => year?.startsWith("FY"))
      .sort((a, b) => b.localeCompare(a))
      .slice(0, 2)
      .sort((a, b) => a.localeCompare(b)); // Get the latest two years

    const geoLatestYears = Object.keys(geo_wise_revenue_analysis?.[0] || {})
      .filter((year) => year.startsWith("FY")) // Get only financial years
      .sort((a, b) => b.localeCompare(a)) // Sort in descending order
      .slice(0, 2) // Get the latest two years
      .map((year) => year.replace("FY", "")) // Remove "FY"
      .sort((a, b) => a.localeCompare(b)); // Sort in ascending order

    setGeoLatestYearsFields({
      fy_fields: geoLatestFYYears,
      fy_years: geoLatestYears,
    });
    setRevenueByGeographyTableData(geo_wise_revenue_analysis || []);
  };

  // useEffect(() => {
  //   fetchRevenueAnalysisData();
  // }, [bu_wise_revenue_analysis_loading, geo_wise_revenue_analysis_loading]);
  //Updated according to new API response
  useEffect(() => {
    if (!bu_wise_revenue_analysis_loading && !geo_wise_revenue_analysis_loading) {
      fetchRevenueAnalysisData();
    }
  }, [bu_wise_revenue_analysis_loading, geo_wise_revenue_analysis_loading, bu_wise_revenue_analysis, geo_wise_revenue_analysis]);

  if (
    Object.values(segmentsLatestYearsFields?.fy_fields).length <= 0 &&
    Object.values(geoLatestYearsFields?.fy_fields).length <= 0
  ) {
    return <></>;
  }

  return (
    <div className="custom_card_block">
      <div className="revnue_analysis_wrapper mb-2">
        <div className="head_top">
          <h5 className="main_head">Revenue Analysis </h5>
        </div>
        <div className="table_block">
          <div className="row">
            {Object.values(segmentsLatestYearsFields?.fy_fields).length > 0 && (
              <div
                className={`custom_hr ${Object.values(geoLatestYearsFields?.fy_fields).length > 0
                  ? "col-md-6"
                  : "col-md-12"
                  }`}
              >
                <div className="table-responsive mr-4">
                  <table className="table rev_table">
                    <thead className="rev_table_thead">
                      <tr>
                        <th className="rev_table_th_first">
                          Revenue, By Segment
                        </th>
                        <th className="rev_table_th">
                          {segmentsLatestYearsFields?.fy_years?.[0]}
                        </th>
                        <th className="rev_table_th">
                          {segmentsLatestYearsFields?.fy_years?.[1]}
                        </th>
                        <th className="rev_table_th">
                          % Chg (Y<span className="italic_dash">|</span>Y)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {revenueBySegmentsTableData?.map((row_data, index) => {
                        const field0 =
                          row_data?.[segmentsLatestYearsFields?.fy_fields?.[0]];
                        const field1 =
                          row_data?.[segmentsLatestYearsFields?.fy_fields?.[1]];

                        // Skip rendering the row if either field is invalid
                        if (
                          field0 === undefined ||
                          field0 === "" ||
                          isNaN(field0) ||
                          field1 === undefined ||
                          field1 === "" ||
                          isNaN(field1)
                        ) {
                          return null;
                        }

                        const truncate_limit =
                          Object.values(geoLatestYearsFields?.fy_fields)
                            .length > 0
                            ? 25
                            : 200;

                        return (
                          <tr key={index} className="rev_tr">
                            <td className="rev_table_td_first">
                              <div className="first_td_color">
                                <div className="progress custom_progress">
                                  <div
                                    className="progress-bar custom_progress_bar"
                                    role="progressbar"
                                    style={{
                                      width: `${row_data?.bu_pie_share}%`,
                                    }}
                                    aria-valuenow={row_data?.bu_pie_share}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip className="custom-tooltip">
                                          {row_data?.name}
                                        </Tooltip>
                                      }
                                    >
                                      <span className="bar_span cursorP">
                                        {truncateDescription(
                                          row_data?.name,
                                          truncate_limit
                                        ).isTruncated
                                          ? truncateDescription(
                                            row_data?.name,
                                            truncate_limit
                                          ).truncated_info + "..."
                                          : row_data?.name}
                                      </span>
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="rev_table_td">
                              {numberWithCommas(
                                smartDecimalNumberFormatter(field0)
                              )}
                            </td>
                            <td className="rev_table_td">
                              {numberWithCommas(
                                smartDecimalNumberFormatter(field1)
                              )}
                            </td>
                            <td className="rev_table_td">
                              {row_data?.bu_revenue_growth < 0 ? (
                                <span className="red_value">
                                  {row_data?.bu_revenue_growth?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 1,
                                      maximumFractionDigits: 1,
                                    }
                                  )}
                                </span>
                              ) : (
                                row_data?.bu_revenue_growth?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                  }
                                )
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {Object.values(geoLatestYearsFields?.fy_fields).length > 0 && (
              <div
                className={`${Object.values(segmentsLatestYearsFields?.fy_fields).length > 0
                  ? "col-md-6"
                  : "col-md-12"
                  }`}
              >
                <div className="table-responsive ml-4">
                  <table className="table rev_table">
                    <thead className="rev_table_thead">
                      <tr>
                        <th className="rev_table_th_first">
                          Revenue, By Geography
                        </th>
                        <th className="rev_table_th">
                          {geoLatestYearsFields?.fy_years?.[0]}
                        </th>
                        <th className="rev_table_th">
                          {geoLatestYearsFields?.fy_years?.[1]}
                        </th>
                        <th className="rev_table_th">
                          % Chg (Y<span className="italic_dash">|</span>Y)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {revenueByGeographyTableData?.map((row_data, index) => {
                        const field0 =
                          row_data?.[geoLatestYearsFields?.fy_fields?.[0]];
                        const field1 =
                          row_data?.[geoLatestYearsFields?.fy_fields?.[1]];

                        // Skip rendering the row if either field is invalid
                        if (
                          field0 === undefined ||
                          field0 === "" ||
                          isNaN(field0) ||
                          field1 === undefined ||
                          field1 === "" ||
                          isNaN(field1)
                        ) {
                          return null;
                        }

                        const truncate_limit =
                          Object.values(segmentsLatestYearsFields?.fy_fields)
                            .length > 0
                            ? 25
                            : 200;

                        return (
                          <tr key={index} className="rev_tr">
                            <td className="rev_table_td_first">
                              <div className="first_td_color">
                                <div className="progress custom_progress">
                                  <div
                                    className="progress-bar custom_progress_bar"
                                    role="progressbar"
                                    style={{
                                      width: `${row_data?.geo_segment_pie_share}%`,
                                    }}
                                    aria-valuenow={
                                      row_data?.geo_segment_pie_share
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip className="custom-tooltip">
                                          {row_data?.name}
                                        </Tooltip>
                                      }
                                    >
                                      <span className="bar_span cursorP">
                                        {truncateDescription(
                                          row_data?.name,
                                          truncate_limit
                                        ).isTruncated
                                          ? truncateDescription(
                                            row_data?.name,
                                            truncate_limit
                                          ).truncated_info + "..."
                                          : row_data?.name}
                                        {/* {row_data?.name} */}
                                      </span>
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="rev_table_td">
                              {" "}
                              {numberWithCommas(
                                smartDecimalNumberFormatter(
                                  row_data?.[
                                  geoLatestYearsFields?.fy_fields?.[0]
                                  ]
                                )
                              )}{" "}
                            </td>
                            <td className="rev_table_td">
                              {" "}
                              {numberWithCommas(
                                smartDecimalNumberFormatter(
                                  row_data?.[
                                  geoLatestYearsFields?.fy_fields?.[1]
                                  ]
                                )
                              )}{" "}
                            </td>
                            <td className="rev_table_td">
                              {row_data?.yoy_rate < 0 ? (
                                <span className="red_value">
                                  {row_data?.yoy_rate?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 1,
                                      maximumFractionDigits: 1,
                                    }
                                  )}
                                </span>
                              ) : (
                                row_data?.yoy_rate?.toLocaleString(undefined, {
                                  minimumFractionDigits: 1,
                                  maximumFractionDigits: 1,
                                })
                              )}{" "}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
